export default __webpack_public_path__ + "static/media/ME-CEH.70a9b0dd.png";